import type { SerialNumber } from "~domain/devices/models/common-device-model.ts";
import type { PilotHwId } from "~domain/devices/models/pilot/pilot-model.ts";
import type { InstallTestVxResultId } from "~domain/install-tests/models/vx/install-test-vx-model.ts";

import { z } from "zod";

export const backofficeFindVxInstallTestsResponseSchema = z
  .object({
    applianceName: z.string().nullable(),
    deviceType: z.string(),
    location: z.string().nullable(),
    serialNumber: z.string().transform((s) => s as SerialNumber),
    testResults: z
      .object({
        gatewayHwId: z.number().transform((s) => s as PilotHwId),
        id: z.number().transform((s) => s as InstallTestVxResultId),
        isAutoTestAllowed: z.boolean(),
        isModulationOk: z.boolean().nullable(),
        measuredPower: z.number().nullable(),
        serverReceptionDateTime: z.coerce.date().nullable(),
        testEndGatewayDateTime: z.coerce.date().nullable(),
        testResult: z.string(),
        testStartGatewayDateTime: z.coerce.date(),
      })
      .array(),
  })
  .array();

export type BackofficeFindVxInstallTestsResponse = z.infer<typeof backofficeFindVxInstallTestsResponseSchema>;
